// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"3bf210e9","268":"bfa1ef3a","312":"78b72723","484":"38d48ca7","640":"84e8c56d","828":"3464384d","950":"6baecfaa"}[chunkId] + ".chunk.js";
};